import Component from '../lib/Component'
import { addClass } from '../lib/Utils'

export default class FullScreenTabs extends Component {
    static selector = '[data-fullscreen-tabs]'

    initialize() {
        this.holder = this.$el
        this.windowWidth = window.innerWidth

        this.initItem(this.holder)
    }

    initItem(holder) {
        const tab = holder.querySelectorAll('.js-fullscreen-tab'),
            tabContent = holder.querySelectorAll(
                '.c-fullscreen-tabs__tab-content',
            ),
            tabContentInner = holder.querySelector(
                '.c-fullscreen-tabs__content-inner',
            ),
            tabWrapper = holder.querySelector(
                '.c-fullscreen-tabs__tab-wrapper',
            ),
            tabBackground = holder.querySelectorAll(
                '.c-fullscreen-tabs__background',
            ),
            tabWidth = tab[0].offsetWidth,
            tabHeight = tab[0].offsetHeight,
            header = document.querySelector('.js-header'),
            headerHeight = header.offsetHeight

        addClass(holder, 'is-ready')
        addClass(tab[tab.length - 1], 'is-active')

        if (this.windowWidth > 800) {
            const tabsWidth = tabWidth * tab.length
            holder.style.height = `calc(100vh - ${headerHeight}px)`
            tab[tab.length - 1].style.width = `calc(100vw + 2px - ${
                tabWidth * (tab.length - 1)
            }px)`
            tabContent.forEach((content) => {
                content.style.width = `calc(100vw + 2px - ${tabsWidth}px)`
                content.style.left = `${tabWidth}px`
            })
            tabWrapper.style.width = `calc(100vw + 2px - ${tabsWidth}px)`
            header.style.width = '100%'

            tab.forEach((t) => {
                t.addEventListener('click', () => {
                    tab.forEach((t) => {
                        t.classList.remove('is-active')
                        t.style.width = `${tabWidth}px`
                    })
                    t.classList.add('is-active')
                    t.style.width = `calc(100vw + 2px - ${
                        tabWidth * (tab.length - 1)
                    }px)`
                })
            })
        } else {
            const tabsHeight = tabHeight * tab.length
            // holder.style.minHeight = `calc(100vh - ${headerHeight}px)`
            tab[tab.length - 1].style.minHeight = `100vh`

            tabContent.forEach((content) => {
                content.style.minHeight = `calc(100vh + 2px)`
                content.style.top = `${tabHeight}px`
            })
            tabBackground.forEach((bg) => {
                bg.style.height = `calc(100vh - ${
                    tabHeight * (tab.length - 1)
                }px)`
            })
            tabContent[0].style.height = `calc(100vh - ${
                tabHeight * tab.length + headerHeight
            }px)`
            tabWrapper.style.minHeight = `${tabHeight}px`

            tab.forEach((t) => {
                t.addEventListener('click', () => {
                    tab.forEach((t) => {
                        t.classList.remove('is-active')
                        t.style.minHeight = `${tabHeight}px`
                    })
                    t.classList.add('is-active')
                    t.style.minHeight = `calc(100vh - ${
                        tabHeight * (tab.length - 1)
                    }px)`
                })
            })
        }
    }
}
